module.exports = __webpack_public_path__ + "img/person.6691298f.jpg";